<template>
  <div class="ergebnis">
    <h4>Jetzt anlegen</h4>
    <div class="ergebnis__content">
      <div class="anlage mr-2 mb-2"
           @click="chooseOption(0)"
           :class="{'active': isActive === 0}">
        <span class="anlage__title">{{ possibleOptions[0].label }}</span>
        <i class="icon" :class="possibleOptions[0].icon"></i>
      </div>
      <div class="anlage mb-2"
           @click="chooseOption(1)"
           :class="{'active': isActive === 1}">
        <span class="anlage__title">{{ possibleOptions[1].label }}</span>
        <i class="icon" :class="possibleOptions[1].icon"></i>
      </div>
      <div class="anlage mr-2 mb-2"
           @click="chooseOption(2)"
           :class="{'active': isActive === 2}">
        <span class="anlage__title">{{ possibleOptions[2].label }}</span>
        <span class="icon" :class="possibleOptions[2].icon"></span>
      </div>
      <div class="anlage mb-2"
           @click="chooseOption(3)"
           :class="{'active': isActive === 3}">
        <span class="anlage__title">{{ possibleOptions[3].label }}</span>
        <i class="icon" :class="possibleOptions[3].icon"></i>
      </div>
    </div>
    <div class="ergebnis__footer">
      <button class="btn btn-secondary" @click="reloadPage">Erneut berechnen
      </button>
      <button class="btn btn-primary" @click="makeDate">Termin vereinbaren
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "anlagemglk",
  data() {
    return {
      isActive: 0,
      possibleOptions: [
        {
          label: "Tagesgeld",
          url: "",
          icon: "icon-tagesgeld"
        },
        {
          label: "Fonds",
          url: "",
          icon: "icon-fond"
        },
        {
          label: "Depot",
          url: "",
          icon: "fas fa-chart-line"
        },
        {
          label: "Anlage Assistent",
          url: "",
          icon: "icon-assistant"
        }
      ]
    }
  },
  methods: {
    reloadPage(){
      window.location.reload()
    },
    chooseOption(option) {
      this.isActive = option;
      window.open(this.possibleOptions[option].url, '_blank');
    },
    makeDate() {
      window.open('', '_blank');
    }
  }
}
</script>

<style scoped lang="scss">
.ergebnis {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;

  &__content {
    flex-grow: 2;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    padding: 1rem 0;
    min-height: 420px;

    // 992px window width and more
    @include lg {
      padding: 1rem 0;
    }

    @include rwd(992) {
      padding: 2rem 0;
    }

    .anlage {
      $this: &;
      width: calc(50% - 2rem);
      border: 1px solid $gray;
      border-radius: $border-radius;
      flex-grow: 2;
      color: rgba($gray, .79);
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      padding: .5rem 0;

      // 992px window width and more
      @include lg {
        padding: 2rem 0;
        width: calc(50% - 4rem);
      }

      .icon {
        font-size: 2.5rem;
        @include md { font-size: 4rem;}
        @include lg { font-size: 3rem; }
        @include rwd(1400) { font-size: 4rem; }
        &:before {
          color: rgba($gray, .79);
        }
      }

      &__title {
        display: inline-block;
        font-size: $font-size-sm;
        margin-bottom: .5rem;
        color: rgba($gray, .79);

        @include md {
          font-size: $font-size-md;
          margin-bottom: 1rem;
        }

        @include lg {
          font-size: $font-size-base;
          margin-bottom: 1rem;
        }
        @include rwd(1400) {
          font-size: $font-size-lg;
        }
      }

      &:hover,
      &.active {
        border-color: $primary;
        background: rgba($primary-background, .4);
        .anlage__title {
          color: $primary;
        }

        .icon {
          color: $primary;
          &:before,
          span:not(:last-child):before {
            color: $primary;
          }
        }
      }
    }
  }

  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    button {
      max-width: 50%;
    }
    button.btn-primary {
      margin-left: .5rem;
      max-width: 47%;
    }
    button.btn-secondary {
      margin-right: .5rem;
    }
  }
}
</style>
